<template>
  <v-card class="elevation-0">
    <v-card-title tabindex="-1">
      <span class="headline">Add stock</span>
    </v-card-title>
    <v-card-text>
      <v-form v-on:submit.prevent width="100%" ref="createForm">
        <v-text-field
          v-model="createFields.quantity"
          label="Number of stocks to add *"
          :error-messages="inputErrorMessages('quantity')"
          v-on:keyup.enter="saveStock"
        />
        <v-text-field
          v-model="createFields.cost"
          label="Acquisition cost *"
          :error-messages="inputErrorMessages('cost')"
          v-on:keyup.enter="saveStock"
        />
        <v-menu
          v-model="datePickerMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="createFields.date_received"
              label="Date Received *"
              readonly
              :error-messages="inputErrorMessages('date_received')"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="createFields.date_received"
            @input="datePickerMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-form>
      <small>* indicates required field</small>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="saveStock">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data: function() {
    return {
      datePickerMenu: false,
      validationRules: {},
      errorMessages: {},
      createFields: {
        date_received: this.currentDate(),
        cost: 0,
        quantity: 1
      }
    };
  },
  computed: {},
  mounted() {},
  props: {},
  methods: {
    ...mapActions(['Product/getProduct']),
    currentDate() {
      var today = new Date();
      var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
      return date;
    },
    clearCreate() {
      this.createFields = {
        name: ''
      };
      this.$refs.createForm.resetValidation();
    },
    rem(name) {
      return `${name} is required`;
    },
    inputErrorMessages(input) {
      return this.errorMessages[input];
    },
    saveStock() {
      if (this.$refs.createForm.validate()) {
        this.loading = true;
        axios
          .post(`api/v1/product/${this.$route.params.id}/inventory`, this.createFields)
          .then(response => {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'Product Type created successfully...',
              color: 'success'
            });
            this.errorMessages = [];
            this.$refs.createForm.resetValidation();
            this.clearCreate();
            this['Product/getProduct']({ id: this.$route.params.id });
            this.$emit('added');
          })
          .catch(response => {
            this.errorMessages = response.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
};
</script>